import React from 'react'
import styled from 'styled-components'
import { deviceLessThan, deviceGreaterThan } from '../../styles/breakpoints';

/**
* Product List
*
*/

export const CarouselWrapper = styled.div`
    position: relative;
    margin: 20px auto;
    text-align:center;
    min-width:100%;
`;

export const CarouselWrapperContainer = styled.div`
    background-color:#6fb7ea;
    width:100%;
    background:${props => props.background ? `url(${props.background}) #48a3ed no-repeat` : "#48a3ed no-repeat"};
    background-size:100% 100%;
    padding:20px 10px
`;

export const CarouselContainer = styled.div`
    width:100%;
    background-size:100% 100%;
    text-align:center;
    padding:${props => props.padding && props.padding};
    position:relative;
    background:${props => props.background && props.background};
    &::after{
        content:"";
        position:absolute;
        background:${props => props.backgroundAfter && props.backgroundAfter};
        bottom: -36%;
        right: -12%;
        width: 65px;
        height: 100%;
        transform: rotate(90deg) scale(1.2);
        @media ${deviceLessThan.tablet} {
            display: none;
        }
    }
    position: relative;
    border-bottom-left-radius:${props => props.borderRadiusBottomLeft};
    border-bottom-right-radius:${props => props.borderRadiusBottomRight};
    @media ${deviceLessThan.tablet} {
        background:${props => props.sBackground && props.sBackground};
        border-bottom-left-radius:${props => props.sBorderRadiusBottomLeft};
        border-bottom-right-radius:${props => props.sBorderRadiusBottomRight};
    }
`;

export const ItemCard = styled.div`
    text-align: center;
    color: white;
    font-size: 16px;
    display: inline-block;
    border-radius: 6px;
    transition: all 1s ease-in-out;

    width:${props => props.width && props.width };
    max-width:${props => props.maxWidth && props.maxWidth };
    position: relative;
    display: inline-block;
    box-shadow:${props => props.boxShadow && props.boxShadow};
`;

export const ItemText = styled.div`
    background:${props => props.background && props.background};
    border-radius:${props => props.borderRadius && props.borderRadius};
    & > p:first-child{
        letter-spacing:1.03px;
    }
`;
